module.exports = __webpack_public_path__ + "assets/ca0da2d13272827c26f1cabb7cf91b2b.png";